/**
 * Flux queries for device role (Primary / Secondary).
 * Measurement: ezelink_role_value — value 1 = Primary, 0 = Secondary
 */

export function createQuery(host) {
  // Current role snapshot (dashboard card)
  return `
from(bucket: "telegraf")
  |> range(start: -15m)
  |> filter(fn: (r) => r["_measurement"] == "ezelink_role_value")
  |> filter(fn: (r) => r["host"] == "${host}")
  |> yield(name: "mean")
`
}

export function createHistoryQuery(host, start, end, interval) {
  // Role over time (history page)
  return `
from(bucket: "telegraf")
  |> range(start: ${start}, stop: ${end})
  |> filter(fn: (r) => r["_measurement"] == "ezelink_role_value")
  |> filter(fn: (r) => r["host"] == "${host}")
  |> aggregateWindow(every: ${interval}, fn: mean, createEmpty: false)
  |> yield(name: "mean")
`
}

export function roleLabel(value) {
  const n = Number(value)
  if (Number.isNaN(n)) return 'No Data Available'
  // mean() can produce floats; round to nearest 0/1
  return Math.round(n) === 1 ? 'Primary' : 'Secondary'
}
